var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImselected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2706"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2705",
    transform: "translate(0 .074)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 115",
    transform: "translate(0 -.074)",
    fill: "#fff",
    stroke: "#5300f2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 116",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(3 2.926)",
    fill: "#5300f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImselected);
export default __webpack_public_path__ + "static/media/imselected.2ddf02ab2d7f9ac59027cf260299517e.svg";
export { ForwardRef as ReactComponent };